<app-uni-page
  [parent]="this"
  *ngIf="isPageReady"
  pageTitle="Inventory: Add Inventory"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
></app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <app-ag-grid [gridOptions]="idsGridOptions"></app-ag-grid>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <div class="qb-child-actions shrink-0">
          <span class="font-semibold">New Item Details</span>
        </div>
        <app-ag-grid [gridOptions]="newItdGridOptions" [rowData]="itdProxies" class="flex-1 min-h-0"></app-ag-grid>
        <ng-template #delButtonCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" (click)="deleteItemDetail(row)">Del</button>
        </ng-template>
        <ng-template #accountButtonCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" (click)="selectAccount(row)">Select Account</button>
        </ng-template>
        <ng-template #issButtonCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" (click)="selectProduct(row)">Select Product</button>
        </ng-template>
        <ng-template #addModButtonCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" (click)="addItemDetailAddon(row)">Add Add-On</button>
        </ng-template>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button *ngIf="itdProxies.length === 0" pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
    <button *ngIf="itdProxies.length > 0" pButton type="button" class="p-button-raised" icon="pi pi-check" (click)="saveChanges()">
      <span>Save</span>
    </button>
    <button *ngIf="itdProxies.length > 0" pButton type="button" class="p-button-raised ml-2" icon="pi pi-undo" (click)="cancelChanges()">
      <span>Undo</span>
    </button>
  </div>
</ng-template>
